import { SectionListType, SectionType } from "../../../types/sectionType";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section2a from "./Section2a";
import Section2b from "./Section2b";
import Section2c from "./Section2c";
import Section2d from "./Section2d";
import Section3 from "./Section3";
import Section4Alt from "./Section4Alt";
import Section4 from "./Section4";

export const sections: SectionListType = {
  section1: {
    text: "Section 1 - Applicant's Biographical Information",
    sidebarText: "1 - Biographical Information",
    content: <Section1 />,
  },
  section2: {
    text: "Section 2 - Devices and Eligibility",
    sidebarText: "2 - Devices & Eligibility",
    content: <Section2 />,
  },
  section2a: {
    text: "Section 2a - Ambulation Aids",
    sidebarText: "2a - Ambulation Aids",
    subsection: true,
    content: <Section2a />,
  },
  section2b: {
    text: "Section 2b - Manual Wheelchairs",
    sidebarText: "2b - Manual Wheelchairs",
    subsection: true,
    content: <Section2b />,
  },
  section2c: {
    text: "Section 2c - Power Bases and Power Scooters",
    sidebarText: "2c - Power Bases & Power Scooters",
    subsection: true,
    content: <Section2c />,
  },
  section2d: {
    text: "Section 2d  –  Positioning Devices (Seating) for Mobility",
    sidebarText: "2d - Positioning Devices",
    subsection: true,
    content: <Section2d />,
  },
  section3: {
    text: "Section 3 - Applicant’s Consent and Signature",
    sidebarText: "3 - Applicant's Consent & Signature",
    content: <Section3 />,
  },
  section4Alt: {
    text: "Pages and Attachments Being Submitted",
    sidebarText: "Pages and Attachments",
    content: <Section4Alt />,
  },
  section4: {
    text: "Section 4 - Signatures",
    sidebarText: "4 - Signatures",
    content: <Section4 />,
  },
};

export const summary: SectionType = {
  text: "Submission Overview",
  sidebarText: "[Not Needed]",
  content: null, // Use manual <Summary setSummarySection={...} />
};
